var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('NbIcon',{class:`${_vm.size} cursor-help`,attrs:{"id":_vm.id,"icon":"help-circle","attributes":_vm.computedAttributes}}),_c('b-popover',{attrs:{"placement":_vm.placement,"target":_vm.externalId || _vm.id,"triggers":"hover focus","variant":"dark"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }